// src/pages/Contents/ContentDetailPage.js
import React from 'react';
import ContentDetail from './components/ContentDetail';
import { ContentProvider } from '../../contexts/ContentContext';

const ContentDetailPage = () => {
  return (
    <ContentProvider>
      <ContentDetail />
    </ContentProvider>
  );
};

export default ContentDetailPage;